import * as yup from 'yup';

export const validationSchema = yup.object({
    locationName: yup
        .string()
        .required('Required'),
    locationCode: yup
        .string()
        .required('Required'),
    picName: yup
        .string()
        .required('Required'),
    email: yup
        .string()
        .email('Enter a valid email')
        .required('Email is required'),
    contactno: yup
        .number()
        .typeError("Only number")
        .required('Required')
        .test(
            "is-positive",
            "Please enter a positive number",
            (value) => value >= 0 && 1 / value !== -Infinity),
    address: yup
        .string()
        .required('Required'),
    // address2: yup
    //     .string()
    //     .required('Required'),
    postcode: yup
        .string()
        .required('Required'),
    areaId: yup
        .string()
        .required('Required'),
    countryId: yup
        .string()
        .required('Required'),
    stateId: yup
        .string()
        .required('Required'),

}).required();

export const initialValues = {
    locationName: "",
    locationCode: "",
    picName: "",
    contactno: "",
    email: "",
    address: "",
    address2: "",
    postcode: "",
    areaId: "",
    countryId: "",
    stateId: "",
    status: true,
    defaultStatus: false
}